import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export const useRemovePaymentMethod = () => {
  const { mutateAsync, isLoading, isSuccess } = useMutation((paymentMethodId: number) =>
    api.delete(API_URL.PAYMENT_METHODS_BY_ID(paymentMethodId))
  );
  return {
    remove: mutateAsync,
    isLoading,
    isSuccess,
  };
};
